import { BlocksRenderer as StrapiBlocksRenderer } from '@strapi/blocks-react-renderer'
import { BlocksRendererProps, FixedLinkInlineNode } from 'components/blocks-renderer/types'
import Link from 'components/link/Link'

const BlocksRenderer = ({ blocks, ...props }: BlocksRendererProps) => {
  return (
    <StrapiBlocksRenderer
      {...props}
      blocks={{
        link: ({ url, children, rel, target }: FixedLinkInlineNode) => {
          const isInternalLink = url.startsWith('https://boltenergie.be') || url.startsWith('https://www.boltenergie.be')

          if (isInternalLink) {
            const path = url.split('boltenergie.be')[1]

            return (
              <Link variant="inline" href={path} {...{ rel, target }}>
                {children}
              </Link>
            )
          }

          return (
            <Link as="a" variant="inline" href={url} {...{ rel, target }}>
              {children}
            </Link>
          )
        },
        ...blocks
      }}
    />
  )
}

export default BlocksRenderer
